<div class="flex justify-content-center">
    <div class="questions-container flex flex-column align-items-center">
        <h1>Gracias por responder la encuesta</h1>
        <p>Tus respuestas nos ayudan a mejorar</p>
    </div>
</div>